import './index.css'
import { useCallback, useContext, useEffect, useState } from 'react';
import { StepTwoFormContext } from '../../../../contexts';
import { ColSize, ContentSection, RowSize, SelectForm } from '../../../../../../../../../../../shared/components';
import { ValidateForm } from '../../../../../../../../../../../shared/utils';
import { MasterContext } from '../../../../../../../../../../../shared/contexts';
import { QuotationInfoContext } from '../../../../../../../shared';
import { getExplanatoryTexts } from '../../../../../../../utils';
import { Typography } from 'antd';
import { COLORS } from '../../../../../../../../../../../config/themes/colors';

interface PlanSectionProps {
  id:             number;
  duplicateId?:   number
}

export const PlansSection = ({ id, duplicateId }: PlanSectionProps) => {
  const validateForm = new ValidateForm();
  
  const { stepTwoForm, planOptionsBySelectedPlan } = useContext(StepTwoFormContext);

  const { globalPublicConfigs } = useContext(MasterContext);
  const { quotationInfo } = useContext(QuotationInfoContext);
  const [explanatoryText, setExplanatoryText] = useState<string>("");    
  
  const handleExplanatoryText = useCallback(() => {
    const plan = stepTwoForm?.getFieldValue(`plan-tab-${id}`);
    const text = getExplanatoryTexts(
      Number(quotationInfo?.branch),
      Number(quotationInfo?.article),
      Number(plan),
      globalPublicConfigs?.QUOTATION_EXPLANATORY_TEXTS
    );
    setExplanatoryText(text);
    stepTwoForm?.setFieldValue(`explanatory-text-tab-${id}`, text);
  }, [stepTwoForm, id, quotationInfo?.branch, quotationInfo?.article, globalPublicConfigs]);

  useEffect(() => {
    handleExplanatoryText();
    if (duplicateId) {
      const duplicatePlan = stepTwoForm?.getFieldValue(`plan-tab-${duplicateId}`);
      stepTwoForm?.setFieldValue(`plan-tab-${id}`, duplicatePlan)
    }
  }, [duplicateId, stepTwoForm, id, handleExplanatoryText]);

  return (
    <ContentSection title='Planes' level='h3'>
      <RowSize>
        <ColSize size={25}>
          <SelectForm 
            formProps={{
              label: 'Lista de Planes:',
              name: `plan-tab-${id}`,
              rules: validateForm.generateRules({
                label: 'lista de planes',
                rules: ['required'],
              }),
            }}
            selectProps={{
              options: planOptionsBySelectedPlan,
              onChange: handleExplanatoryText,
            }}
          />
        </ColSize>
      </RowSize>
      {!!explanatoryText && 
        <Typography.Text strong style={{ fontSize: 16, color: COLORS.neutrals[70] }} >
          {explanatoryText}
        </Typography.Text>
        }        
    </ContentSection>
  );
};
